import React, { useState } from 'react'
import '../style/_SubHeader.scss'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Radio from '@mui/material/Radio';
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimateSharedLayout, AnimatePresence } from 'framer-motion'
import {ReactComponent as Light} from '../assets/new-icons/light.svg';
import {ReactComponent as Gas} from '../assets/new-icons/gas.svg';
import {ReactComponent as Close} from '../assets/new-icons/close.svg';
import { setOverlayNotice, setRicarica3612Effettuata, setSection, setSwitchGraphMonth, setSwitchGraphYear, setSwitchMonth, setSwitchWeek, setView } from '../features/settingSlice';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { setCurrentBalance, setCurrentBalanceEnrica, setCurrentPod, setDatiPagamento, setExpiryBalanceEnrica, setInfo, setLoggedIn, setNomePrenotazione, setOfferta, setPodsList } from '../features/userSlice';
import { setDataMin } from '../features/dataMonthSlice';
import { DateTime } from 'luxon';
import { setDataBox } from '../features/dataBoxHomeSlice';
import { setDatiPagamentoGas, setInfoGas, setNotifiche, setSaldoGas } from '../features/gasSlice';
import {useFetchLoginGas} from '../functions/loginGas'

function SubHeader({inMenu = false}) {
    
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const address = useSelector((user) => user?.user?.currentPod?.podAddress)
    const currentPod = useSelector((user) => user?.user?.currentPod?.podCode)
    const addressList = useSelector((user) => user?.user?.podsList)
    const energy = useSelector((user) => user.settings.section)
    const [selectedId, setSelectedId] = useState(false);
    const section = useSelector((user) => user.settings.section)
    const fetchLoginGas = useFetchLoginGas()
    const arrayList = addressList && addressList.map((r) => r.customerCode.includes('RG-'));
    function isGasForniture(pod) {
        return pod.customerId > 200000;
    }
    const gasArray = addressList && addressList.filter((r) => r.customerCode.includes('RG-'))
    const enerArray = addressList && addressList.filter((r) => r.customerCode.includes('RL-'))

    const handleFornitura = async (pod) => {
        const fakeLogin = `https://my.revoluce.it/area_utente/gestione/api/login/fakeLogin.php?username=${pod.username}&password=${pod.password}`;
        if(isGasForniture(pod)){
            fetchLoginGas(pod)
            navigate('/enrica/gas')
            // const fakeGasLogin = `https://my.revoluce.it/area_utente/gestione/api/login/fakeLoginGas.php?username=${pod.username}` ;
            // await axios.get(fakeGasLogin).then(({ data }) => {
            //      localStorage.setItem('section', true)
            //      let notifiche = []
            //      notifiche = [data.notificheRid, data.notificheToken]
            //      dispatch(setNotifiche(notifiche))
            //      dispatch(setSection(true))
            //      dispatch(setSaldoGas(data.saldo))
            //      const result = data.data.altri_dati_pod;
            //      dispatch(setInfoGas(data.data))
            //      dispatch(setDatiPagamentoGas(data.dati_pagamento))
            //      dispatch(setCurrentPod({podCode: result.pod_code, podName: result.name_extended, podAddress: result.pod_address}))
            //      navigate('/enrica/gas')
            // })
        } else {
            dispatch(setSection(false))
            const { data } = await axios.get(fakeLogin)
            navigate("/enrica");
            localStorage.setItem('section', false)
            localStorage.setItem('logged', true);
            dispatch(setOfferta(data.nome_offerta))
            dispatch(setDatiPagamento(data.dati_pagamento))
            dispatch(setOverlayNotice(data.flag_popup))
            dispatch(setRicarica3612Effettuata(data.exist_prenotazione))
            dispatch(setNomePrenotazione(data.nome_prenotazione))
            const config = data.config_app;
            dispatch(setDataMin(data.data_min));
            dispatch(setView(config.set_view))
            dispatch(setSwitchWeek(config.graph_week))
            dispatch(setSwitchGraphYear(config.set_graph_year))
            dispatch(setSwitchGraphMonth(config.set_graph_month))
            dispatch(setSwitchMonth(config.set_view_month))
            const result = data.data[0];
            dispatch(setInfo(result))
            dispatch(setLoggedIn())
            dispatch(setCurrentBalance(data.saldo))
            dispatch(setCurrentBalanceEnrica(data.saldo_enrica))
            dispatch(setExpiryBalanceEnrica(data.saldo_in_scadenza))
            dispatch(setCurrentPod({ podCode: result.pod_code, podName: result.nome, podAddress: result.pod_address }))
            const podsApi = `https://my.revoluce.it/area_utente/gestione/api/customers_pods/getCustomerPods2.php?codice_fiscale=${result.customer_tax_code}`
            axios.get(podsApi).then(({ data }) => {
                const podsList = data.data.map((r) => ({podStart: r.pod_start, podStartDate: r.pod_start_date, customerCode: r.customer_code, ownerCity: r.city_name,  ownerAddress: r.pod_address, taxCode: r.customer_tax_code,taxCodeGas: r.customer_tax_code_gas, podOwnerGas: r.customer_full_heading_gas, podOwner: r.customer_full_heading, revoCode: r.codice_revoluzionario, podCode: r.pod_code, podName: r.nome, podAddress: r.pod_address, username: r.user_username, password: r.user_password, customerId: r.customer_id }))
                // const currIndex = podsList.findIndex(pod => pod.podCode === result.pod_code);
                // const currPod = podsList[currIndex];
                // podsList.splice(currIndex, 1);
                // dispatch(setPodsList([currPod, ...podsList]));
                dispatch(setPodsList(podsList))
            })
            const podCode = result.pod_code
            const token = result.token_value
            const userToken = result.user_id
            const dateStart = DateTime.local().startOf("month").toISODate();
            const dateEnd = DateTime.local().endOf("month").toISODate();
            const deliveryMonthNew = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryMonthNew.php?codice_pod=${podCode}&token=${token}&userToken=${userToken}&debug=1&date_start=${dateStart}&date_end=${dateEnd}`;
            axios.get(deliveryMonthNew).then(({ data }) => {
                dispatch(setDataBox(data.data.consumptions))
            })
        }
      
    }

    return (
        <div className="subHeader fornitureclose" style={!inMenu ? {margin: '0px'} : {margin: '6.35vh 0px'}}>
            <div className="flex-column">
                <AnimateSharedLayout type="crossfade" resence>
                    <motion.div layout="0" className="forniture" onClick={() => addressList && addressList.length > 1 ? setSelectedId(true) : setSelectedId(true)}>
                        <div className="text">
                             <p className='label'>La tua fornitura</p>
                            <p className="main" style={inMenu ? {color: 'white'} : null}>{currentPod && currentPod}</p>
                            <p className="address" style={inMenu ? {color: 'white'} : null}>{address && address.toLowerCase()}</p>
                        </div>
                        {addressList && addressList.length > 1 ? (
                            <div className="arrowForward">
                                <ArrowForwardIosIcon/>
                            </div>
                        ) : (
                            <div className="arrowForward">
                                <ArrowForwardIosIcon/>
                            </div>
                        )}
                    </motion.div>
                    <AnimatePresence>
                        {selectedId && (
                            <motion.div className="boxForniture" layout="0">
                                <div className="boxContainer">
                                    <div className="closeIcon" onClick={() => setSelectedId(false)}>
                                        <div className="closeBackground">
                                            <Close/>
                                        </div>
                                    </div>
                                    
                                    <div className="listForniture">
                                        <p className="label">
                                            Le tue utenze
                                        </p>
                                        <div className="energiaBlock">
                                            {enerArray && enerArray.map((pod, i) => (
                                                <div className='item' key={i} onClick={() => handleFornitura(pod)}>
                                                    <div className="iconCheck">
                                                        <div className="input">
                                                            {pod.podCode === currentPod ? (
                                                                <div className='checked' />
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="icon">
                                                        {pod.customerId < 200000 &&  (
                                                            <Light />
                                                        )}
                                                    </div>
                                                    <div className="text">
                                                        <p className="pod">{pod.podCode}</p>
                                                        <p className="address">{pod.podAddress.toLowerCase()}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="divisore" style={{width: '100%', height: '2px', background: '#eee'}} />
                                        <div className="gasBlock" style={{marginTop: '4.09vh'}}>
                                            {gasArray && gasArray.length !== 0 ? gasArray.map((pod, i) => (
                                                <div className='item' key={i} onClick={() => handleFornitura(pod)}>
                                                    <div className="iconCheck">
                                                        <div className="input">
                                                            {pod.podCode === currentPod ? (
                                                                <div className='checked' />
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="icon">
                                                        {!pod.customerId < 200000 &&  (
                                                                <Gas />
                                                        )}
                                                    </div>
                                                    <div className="text">
                                                        <p className="pod">{pod.podCode}</p>
                                                        <p className="address">{pod.podAddress.toLowerCase()}</p>
                                                    </div>
                                                </div>
                                            )) : (
                                                <>
                                                    <p className="label">
                                                        Non hai utenze Gas
                                                    </p>
                                                    <button onClick={() => window.open('https://www.revoluce.it/revogas/', { target: '_blank'})} className='seeMore'>Scopri di più sulla fornitura Gas</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </AnimateSharedLayout>
            </div>
            {!inMenu && (
                <div className="currentCatContainer" onClick={() => addressList && addressList.length > 1 ? setSelectedId(true) : null} >
                    <div className={`luce ${section ? null : 'active'}`}>
                        <Light />
                        <span>Luce</span>
                    </div>
                    {arrayList && arrayList.includes(true) ? (
                        <div className={`gas ${section ? 'active' : null}`}>
                            <Gas/>
                            <span>Gas</span>
                        </div>
                    ) : null}
                </div>
            )}
        </div>
    )
}

export default SubHeader
